import React, { FC } from 'react';

export interface IPasscodeFooterLinkProps {
  label?: string;
  onClick?: () => void;
}

const PasscodeFooterLink: FC<IPasscodeFooterLinkProps> = ({
  label,
  onClick,
}) => (
  <>
    {!!label && !!onClick && (
      <a
        className="text-xs font-medium text-link"
        href=""
        onClick={(e) => {
          e.preventDefault();
          onClick();
        }}
      >
        {label}
      </a>
    )}
  </>
);

export default PasscodeFooterLink;
